const features = {
  getFeatureName(featureId) {
    switch (featureId) {
      case this.$enums.features.PULSE:
        return "Culture Tracking";
      case this.$enums.features.SURVEYS:
        return "Custom Surveys";
      case this.$enums.features.RESOURCE:
        return "Training Resources";
      case this.$enums.features.REVIEW:
        return "360 Reviews";
      case this.$enums.features.CHECK_INS:
        return "Meetings";
      case this.$enums.features.RECOGNITION:
        return "Recognition";
      case this.$enums.features.GOALS:
        return "Goal Tracking";
      case this.$enums.features.ANNUAL_REVIEWS:
        return "Annual Reviews";
      default:
        return "";
    }
  },
  getFeatureReportLink(featureId) {
    switch (featureId) {
      case this.$enums.features.PULSE:
        return "/reporting/culture";
      case this.$enums.features.SURVEYS:
        return "/reporting/surveys";
      case this.$enums.features.RESOURCE:
        return "/reporting/training";
      case this.$enums.features.REVIEW:
        return "/reporting/360-reviews";
      case this.$enums.features.RECOGNITION:
        return "/reporting/recognition";
      case this.$enums.features.GOALS:
        return "/reporting/goals";
      case this.$enums.features.ANNUAL_REVIEWS:
        return "/reporting/annual-reviews";
      default:
        return "";
    }
  },
  isFeaturePerformance(featureId) {
    switch (featureId) {
      case this.$enums.features.RESOURCE:
      case this.$enums.features.GOALS:
      case this.$enums.features.CHECK_INS:
      case this.$enums.features.ANNUAL_REVIEWS:
        return true;
      default:
        return false;
    }
  }
};

export default { methods: features };
